'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function () {
  var Snap = undefined;
  try {
    Snap = require('snapsvg-cjs');
  } finally {
    return Snap;
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-burger-menu/lib/snapsvgImporter.js
// module id = 237
// module chunks = 114276838955818